import type { ChartType, Plugin } from 'chart.js'

export const legendSpacing = <T extends ChartType>(
  width: number = 0,
  height: number = 0,
  legendMarginWidth: number = 0, // Used on pipes only
  legendMarginHeight: number = 0 // Used on distribution with legend on bottom only
): Plugin<T> => ({
  id: 'increase-legend-spacing',
  beforeInit(chart) {
    // We need this assertion to bypass the fact that fit method does not exist in LegendElement type but only in prototype
    const originalFit = (chart.legend as any).fit

    ;(chart.legend as any).fit = function fit() {
      originalFit.bind(chart.legend)()

      // Increase or decrease spacing between chart and right legend of given width
      // HACK: https://stackoverflow.com/questions/73225423
      if (width) {
        let left: number
        const marginLeft = legendMarginWidth

        Object.defineProperty(this, 'left', {
          get() {
            return left + marginLeft
          },
          set(v) {
            left = v
          }
        })

        this.width += width + legendMarginWidth
      }

      // Increase spacing between chart and bottom legend of given height
      // HACK: https://stackoverflow.com/questions/73225423
      if (height) {
        let top: number
        const marginTop = legendMarginHeight

        Object.defineProperty(this, 'top', {
          get() {
            return top + marginTop
          },
          set(v) {
            top = v
          }
        })

        this.height += height + legendMarginHeight
      }
    }
  }
})
